export default __webpack_public_path__ + "static/media/lean_forward.4e18d896.png";